import client from "./client.js";

export async function listApiKeys() {
  const { data } = await client.get("/api-keys");
  return data.data;
}

export async function createApiKey(name) {
  const { data } = await client.post("/api-keys", { name });
  return data.data;
}

export async function deleteApiKey(id) {
  await client.delete(`/api-keys/${id}`);
}
